export default __webpack_public_path__ + "static/media/ninos-Personaje-Banner-04-1.a3742eae.png";